var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSteamWashing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_74",
    "data-name": "Group 74",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 99.335,
    height: 74.873,
    viewBox: "0 0 99.335 74.873",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_58",
    "data-name": "Rectangle 58",
    width: 99.335,
    height: 74.873,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_73",
    "data-name": "Group 73",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_291",
    "data-name": "Path 291",
    d: "M11.128,29.963c.2,0,1.072-.383.617-.383-.2,0-1.073.383-.617.383"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_292",
    "data-name": "Path 292",
    d: "M40.373,25.574l-.014.388,0,31.356a4.008,4.008,0,0,1-8.016,0V24.063l-.015-1.58h0a8.92,8.92,0,0,0-17.838.025V49.761L13.723,49l-6.408-.153L3.85,45.381,0,49.232,20.315,69.547l3.851-3.85L20.7,62.232l-.152-6.408L19.4,54.673V22.6a4.008,4.008,0,1,1,8.016,0l.016,34.809h0a8.92,8.92,0,0,0,17.838,0l.016-31.791a6.841,6.841,0,0,1,4.587-6.447V14.1a11.762,11.762,0,0,0-9.5,11.477"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_293",
    "data-name": "Path 293",
    d: "M79.061,2.276V0H67.638V2.052c.149-.015.3-.038.448-.052a47.627,47.627,0,0,1,10.975.276"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_294",
    "data-name": "Path 294",
    d: "M68.191,2.943a32.7,32.7,0,0,0-6.782,1.592A15.586,15.586,0,0,0,58.7,5.843H89.075c-.035-.025-.062-.052-.1-.077a20.022,20.022,0,0,0-8.328-2.761,46.576,46.576,0,0,0-12.458-.062"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_295",
    "data-name": "Path 295",
    d: "M58.861,74.873a4.043,4.043,0,0,0,3.987-3.411H54.874a4.043,4.043,0,0,0,3.987,3.411"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_296",
    "data-name": "Path 296",
    d: "M87.837,74.873a4.043,4.043,0,0,0,3.987-3.411H83.85a4.043,4.043,0,0,0,3.987,3.411"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_297",
    "data-name": "Path 297",
    d: "M93.826,8.844H52.871V61.538l40.955.518Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_57",
    "data-name": "Rectangle 57",
    width: 51.164,
    height: 5.698,
    transform: "matrix(1, -0.013, 0.013, 1, 48.104, 62.958)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSteamWashing);
export default __webpack_public_path__ + "static/media/steamWashing.00b2904b16915bdee0490581845ee9b4.svg";
export { ForwardRef as ReactComponent };